import React from "react";
import "../styles/styles.css";

function Header() {
  return (
    <header className="menu-header">
      <div className="logo">MARGIN</div>
      {/* Navigation is omitted for a calmer, single-focus landing experience */}
    </header>
  );
}

export default Header;
